"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TerrainTypes;
(function (TerrainTypes) {
    TerrainTypes[TerrainTypes["Water"] = 0] = "Water";
    TerrainTypes[TerrainTypes["Earth"] = 1] = "Earth";
    TerrainTypes["Tree"] = "f";
    TerrainTypes["Spawn"] = "S";
    TerrainTypes["Void"] = "V";
})(TerrainTypes = exports.TerrainTypes || (exports.TerrainTypes = {}));
var CircleTypes;
(function (CircleTypes) {
    CircleTypes[CircleTypes["Round"] = 0] = "Round";
    CircleTypes[CircleTypes["HorizontalEllipse"] = 1] = "HorizontalEllipse";
    CircleTypes[CircleTypes["VerticalEllipse"] = 2] = "VerticalEllipse";
})(CircleTypes = exports.CircleTypes || (exports.CircleTypes = {}));
